import { SVGAttributes, VFC } from "react";

// eslint-disable-next-line react/require-default-props
const Graphic: VFC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 200 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id="a" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="200" height="64">
        <path d="M199 1v62H1V1h198Z" fill="#C4C4C4" stroke="#EF9E85" strokeWidth="2" />
      </mask>
      <g mask="url(#a)" stroke="#FAF6F4" strokeWidth="2">
        <circle cx="-68.436" cy="76.422" r="78.803" transform="rotate(90 -68.436 76.422)" />
        <circle cx="-68.435" cy="76.422" r="95.861" transform="rotate(90 -68.435 76.422)" />
        <circle cx="-68.436" cy="76.422" r="111.553" transform="rotate(90 -68.436 76.422)" />
        <circle cx="-68.437" cy="76.421" r="127.245" transform="rotate(90 -68.437 76.421)" />
        <circle cx="-68.435" cy="76.422" r="144.302" transform="rotate(90 -68.435 76.422)" />
        <circle cx="-68.436" cy="76.422" r="159.995" transform="rotate(90 -68.436 76.422)" />
        <circle cx="-68.435" cy="76.421" r="177.052" transform="rotate(90 -68.435 76.421)" />
        <circle cx="-68.434" cy="76.422" r="193.427" transform="rotate(90 -68.434 76.422)" />
        <circle cx="-68.434" cy="76.422" r="209.801" transform="rotate(90 -68.434 76.422)" />
        <circle cx="-68.438" cy="76.422" r="226.176" transform="rotate(90 -68.438 76.422)" />
        <circle cx="-68.435" cy="75.739" r="241.869" transform="rotate(90 -68.435 75.74)" />
        <circle cx="-68.435" cy="75.739" r="258.243" transform="rotate(90 -68.435 75.74)" />
        <circle cx="-68.434" cy="75.739" r="274.618" transform="rotate(90 -68.434 75.74)" />
        <circle cx="-68.436" cy="75.739" r="290.311" transform="rotate(90 -68.436 75.74)" />
      </g>
    </svg>
  );
};

export { Graphic };
